import { use } from 'react'
import { WorkingDocumentContext } from '../contexts/WorkingDocumentContext'

export function useWorkingDocument() {
  const context = use(WorkingDocumentContext)
  if (!context) {
    throw new Error('useWorkingDocument must be used within WorkingDocumentProvider')
  }
  return context
}
